import Vue from 'vue'
import App from './App.vue'


// import Message from 'vue-multiple-message'
// Vue.prototype.$message = Message

// import 'vant/lib/index.css';

import router from "./router/index.js"


import wow from 'wowjs'

import 'wowjs/css/libs/animate.css'

Vue.prototype.$wow = wow

// import {
// 	Toast
// } from 'vant';
// Vue.use(Toast);

/*  */


/* 语言包 */
import VueI18n from 'vue-i18n';


Vue.use(VueI18n);
// 多语言切换
// const i18n = new VueI18n({
// 	locale: 'ru', //设置默认语言
// 	messages:{
// 		'zh': require('./components/lang/cn'),
// 		'en': require('./components/lang/en')
// 	}
// });
const i18n = new VueI18n({
	locale: localStorage.getItem('lang') || 'en', //设置默认语言
	messages: {
		'en': require('./components/lang/en'),
		'zh': require('./components/lang/cn')
	}
});

Vue.config.productionTip = false

new Vue({
	render: h => h(App),
	router,
	i18n, // 引用i18n
}).$mount('#app')